import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { DEFAULT_END_PARAM, DEFAULT_START_PARAM } from "./useFormsFilters";

export const useInitialValues = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		let shouldUpdate = false;

		if (!searchParams.has("start")) {
			searchParams.set("start", DEFAULT_START_PARAM);
			shouldUpdate = true;
		}

		if (!searchParams.has("end")) {
			searchParams.set("end", DEFAULT_END_PARAM);
			shouldUpdate = true;
		}
		if (!searchParams.has("status")) {
			searchParams.set("status", "All");
			shouldUpdate = true;
		}

		if (shouldUpdate) setSearchParams(searchParams, { replace: true });
	}, [searchParams]);
};
